// Extract the city from a German formatted address. Places usually returns
// "Schlagbaumer Str. 124 a, 42653 Solingen" with no country part, so anchor on
// the postal code — positional guessing returns the street name instead.
export function extractCity(address) {
  if (!address) return "";
  const parts = address.split(",").map((p) => p.trim()).filter(Boolean);
  for (let i = parts.length - 1; i >= 0; i--) {
    const m = parts[i].match(/^\d{4,5}\s+(.+)$/);
    if (m) return m[1].trim();
  }
  const tail = parts[parts.length - 1] || "";
  if (parts.length > 1 && /^(deutschland|germany|türkiye|turkey)$/i.test(tail)) {
    return parts[parts.length - 2].replace(/\d{4,5}/g, "").trim();
  }
  return tail.replace(/\d{4,5}/g, "").trim();
}
